import { Injectable } from '@angular/core';
import { LookupModel, LookupsClient, NotesClient, NotesModel, TourClient, TourModel } from '@core/services/api.service';
import { LoadCategoriesAction, LoadCategoriesFailAction, LoadCategoriesSuccessAction, LoadCustomsDepAction, LoadCustomsDepFailAction, LoadCustomsDepSuccessAction, LoadDeclarationTypesAction, LoadDeclarationTypesFailAction, LoadDeclarationTypesSuccessAction, LoadDepartmentsAction, LoadDepartmentsFailAction, LoadDepartmentsSuccessAction, LoadGetCauseOfIssueUpdateTypesAction, LoadGetCauseOfIssueUpdateTypesFailAction, LoadGetCauseOfIssueUpdateTypesSuccessAction, LoadGetImpactUpdateTypesAction, LoadGetImpactUpdateTypesFailAction, LoadGetImpactUpdateTypesSuccessAction, LoadGetReasonForIssueUpdateTypesAction, LoadGetReasonForIssueUpdateTypesFailAction, LoadGetReasonForIssueUpdateTypesSuccessAction, LoadNotesAction, LoadNotesFailAction, LoadNotesSuccessAction, LoadShipmentModesAction, LoadShipmentModesFailAction, LoadShipmentModesSuccessAction, LoadTicketTypesAction, LoadTicketTypesFailAction, LoadTicketTypesSuccessAction, LoadTypeAction, LoadTypeFailAction, LoadTypeSuccessAction, LoadAllTypesAction, LoadAllTypesFailAction, LoadAllTypesSuccessAction } from './lookup.actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';

export class LookupStateModel {
    public showMenu: boolean;
    public isMobileMode: boolean;
    public showSpinner: boolean;
    public tourList: TourModel[];
    public notes: NotesModel[];
    public departments: LookupModel[];
    public typeLookups: LookupModel[];
    public categories: LookupModel[];
    public ticketTypes: LookupModel[];
    public causeOfIssueTypes: LookupModel[];
    public impactTypes: LookupModel[];
    public reasonForIssueTypes: LookupModel[];
    public shipmentModes: LookupModel[];
    public customsDep: LookupModel[];
    public declarationTypes: LookupModel[];
    public allTypes: LookupModel[];
}

@State<LookupStateModel>({
    name: 'lookup',
    defaults: {
        showMenu: true,
        isMobileMode: false,
        showSpinner: false,
        tourList: undefined,
        notes: undefined,
        departments: undefined,
        typeLookups: undefined,
        categories: undefined,
        ticketTypes: undefined,
        causeOfIssueTypes: undefined,
        impactTypes: undefined,
        reasonForIssueTypes: undefined,
        shipmentModes: undefined,
        customsDep: undefined,
        declarationTypes: undefined,
        allTypes: undefined
    }
})
@Injectable()
export class LookupState {
    constructor(private lookupsClient: LookupsClient, private notesClient: NotesClient) {}


    @Selector()
    static getDepartments(state: LookupStateModel) {
      return state.departments;
    }

    @Selector()
    static getTypeLookups(state: LookupStateModel) {
      return state.typeLookups;
    }


    @Selector()
    static getCategories(state: LookupStateModel) {
      return state.categories;
    }

    @Selector()
    static getTicketTypes(state: LookupStateModel) {
      return state.ticketTypes;
    }

    @Selector()
    static getCauseOfIssueUpdateTypes(state: LookupStateModel) {
      return state.causeOfIssueTypes;
    }

    @Selector()
    static getImpactUpdateTypes(state: LookupStateModel) {
      return state.impactTypes;
    }

    @Selector()
    static getReasonForIssueUpdateTypes(state: LookupStateModel) {
      return state.reasonForIssueTypes;
    }


    @Selector()
    static getNotesByTourId(state: LookupStateModel) {
      return state.notes;
    }

    @Selector()
    static getShipmentModes(state: LookupStateModel) {
      return state.shipmentModes;
    }

    @Selector()
    static getCustomsDep(state: LookupStateModel) {
      return state.customsDep;
    }

    @Selector()
    static getDeclarationtypes(state: LookupStateModel) {
      return state.declarationTypes;
    }

    @Selector()
    static getAllTypes(state: LookupStateModel) {
        return state.allTypes;
    }

    @Action(LoadNotesAction)
    loadNotesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadNotesAction) {
      patchState({ showSpinner: true });

      return this.notesClient.getNotesByTourId(action.payload.tourId).pipe(
        tap((notes) => dispatch(new LoadNotesSuccessAction({ notes }))),
        catchError((err) => dispatch(new LoadNotesFailAction()))
      );
    }

    @Action(LoadNotesSuccessAction)
    loadNotesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadNotesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        notes: action.payload.notes
      });
    }

    @Action(LoadNotesFailAction)
    loadNotesFailAction(ctx: StateContext<LookupStateModel>, action: LoadNotesFailAction) {
      ctx.patchState({
        showSpinner: false,
        notes: undefined
      });
    }


    @Action(LoadDepartmentsAction)
    LoadDepartmentsAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadDepartmentsAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getDepartments().pipe(
        tap((departments) => dispatch(new LoadDepartmentsSuccessAction({ departments }))),
        catchError((err) => dispatch(new LoadNotesFailAction()))
      );
    }

    @Action(LoadDepartmentsSuccessAction)
    LoadDepartmentsSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadDepartmentsSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        departments: action.payload.departments
      });
    }

    @Action(LoadDepartmentsFailAction)
    LoadDepartmentsFailAction(ctx: StateContext<LookupStateModel>, action: LoadDepartmentsFailAction) {
      ctx.patchState({
        showSpinner: false,
        departments: undefined
      });
    }

    @Action(LoadTypeAction)
    LoadTypeAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadTypeAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getTypeLookups(action.payload.departmentId).pipe(
        tap((types) => dispatch(new LoadTypeSuccessAction({types}))),
        catchError((err) => dispatch(new LoadTypeFailAction()))
      );
    }

    @Action(LoadTypeSuccessAction)
    LoadTypeSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadTypeSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        typeLookups: action.payload.types
      });
    }

    @Action(LoadTypeFailAction)
    LoadTypeFailAction(ctx: StateContext<LookupStateModel>, action: LoadTypeFailAction) {
      ctx.patchState({
        showSpinner: false,
        typeLookups: undefined
      });
    }

    @Action(LoadCategoriesAction)
    LoadCategoriesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadCategoriesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getCategories().pipe(
        tap((categories) => dispatch(new LoadCategoriesSuccessAction({categories}))),
        catchError((err) => dispatch(new LoadCategoriesFailAction()))
      );
    }

    @Action(LoadCategoriesSuccessAction)
    LoadCategoriesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadCategoriesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        categories: action.payload.categories
      });
    }

    @Action(LoadCategoriesFailAction)
    LoadCategoriesFailAction(ctx: StateContext<LookupStateModel>, action: LoadCategoriesFailAction) {
      ctx.patchState({
        showSpinner: false,
        categories: undefined
      });
    }


    @Action(LoadTicketTypesAction)
    LoadTicketTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadTicketTypesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getTicketTypes().pipe(
        tap((ticketTypes) => dispatch(new LoadTicketTypesSuccessAction({ticketTypes}))),
        catchError((err) => dispatch(new LoadTicketTypesFailAction()))
      );
    }

    @Action(LoadTicketTypesSuccessAction)
    LoadTicketTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadTicketTypesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        ticketTypes: action.payload.ticketTypes
      });
    }

    @Action(LoadTicketTypesFailAction)
    LoadTicketTypesFailAction(ctx: StateContext<LookupStateModel>, action: LoadTicketTypesFailAction) {
      ctx.patchState({
        showSpinner: false,
        ticketTypes: undefined
      });
    }

    //--------------------------------------------

    @Action(LoadGetCauseOfIssueUpdateTypesAction)
    LoadGetCauseOfIssueUpdateTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadGetCauseOfIssueUpdateTypesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getCauseOfIssueUpdateTypes().pipe(
        tap((causeOfIssueTypes) => dispatch(new LoadGetCauseOfIssueUpdateTypesSuccessAction({causeOfIssueTypes}))),
        catchError((err) => dispatch(new LoadGetCauseOfIssueUpdateTypesFailAction()))
      );
    }

    @Action(LoadGetCauseOfIssueUpdateTypesSuccessAction)
    LoadGetCauseOfIssueUpdateTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadGetCauseOfIssueUpdateTypesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        causeOfIssueTypes: action.payload.causeOfIssueTypes
      });
    }

    @Action(LoadGetCauseOfIssueUpdateTypesFailAction)
    LoadGetCauseOfIssueUpdateTypesFailAction(ctx: StateContext<LookupStateModel>, action: LoadGetCauseOfIssueUpdateTypesFailAction) {
      ctx.patchState({
        showSpinner: false,
        causeOfIssueTypes: undefined
      });
    }

    //--------------------------------------------

    @Action(LoadGetImpactUpdateTypesAction)
    LoadGetImpactUpdateTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadGetImpactUpdateTypesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getImpactUpdateTypes().pipe(
        tap((impactTypes) => dispatch(new LoadGetImpactUpdateTypesSuccessAction({impactTypes}))),
        catchError((err) => dispatch(new LoadGetCauseOfIssueUpdateTypesFailAction()))
      );
    }

    @Action(LoadGetImpactUpdateTypesSuccessAction)
    LoadGetImpactUpdateTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadGetImpactUpdateTypesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        impactTypes: action.payload.impactTypes
      });
    }

    @Action(LoadGetImpactUpdateTypesFailAction)
    LoadGetImpactUpdateTypesFailAction(ctx: StateContext<LookupStateModel>, action: LoadGetImpactUpdateTypesFailAction) {
      ctx.patchState({
        showSpinner: false,
        impactTypes: undefined
      });
    }


    //--------------------------------------------

    @Action(LoadGetReasonForIssueUpdateTypesAction)
    LoadGetReasonForIssueUpdateTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadGetReasonForIssueUpdateTypesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getReasonForIssueUpdateTypes().pipe(
        tap((reasonForIssueTypes) => dispatch(new LoadGetReasonForIssueUpdateTypesSuccessAction({reasonForIssueTypes}))),
        catchError((err) => dispatch(new LoadGetReasonForIssueUpdateTypesFailAction()))
      );
    }

    @Action(LoadGetReasonForIssueUpdateTypesSuccessAction)
    LoadGetReasonForIssueUpdateTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadGetReasonForIssueUpdateTypesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        reasonForIssueTypes: action.payload.reasonForIssueTypes
      });
    }

    @Action(LoadGetReasonForIssueUpdateTypesFailAction)
    LoadGetReasonForIssueUpdateTypesFailAction(ctx: StateContext<LookupStateModel>, action: LoadGetReasonForIssueUpdateTypesFailAction) {
      ctx.patchState({
        showSpinner: false,
        reasonForIssueTypes: undefined
      });
    }

    //-----------------------------------------------------
    @Action(LoadShipmentModesAction)
    LoadShipmentModesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadShipmentModesAction) {
      patchState({ showSpinner: true });

      return this.lookupsClient.getShipmentModes().pipe(
        tap((shipmentModes) => dispatch(new LoadShipmentModesSuccessAction({ shipmentModes }))),
        catchError((err) => dispatch(new LoadShipmentModesFailAction()))
      );
    }

    @Action(LoadShipmentModesSuccessAction)
    LoadShipmentModesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadShipmentModesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        shipmentModes: action.payload.shipmentModes
      });
    }

    @Action(LoadShipmentModesFailAction)
    LoadShipmentModesFailAction(ctx: StateContext<LookupStateModel>, action: LoadShipmentModesFailAction) {
      ctx.patchState({
        showSpinner: false,
        shipmentModes: undefined
      });
    }

     //-----------------------------------------------------

     @Action(LoadCustomsDepAction)
     LoadCustomsDepAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadCustomsDepAction) {
       patchState({ showSpinner: true });

       return this.lookupsClient.getCustomsDep().pipe(
         tap((customsDep) => dispatch(new LoadCustomsDepSuccessAction({ customsDep }))),
         catchError((err) => dispatch(new LoadCustomsDepFailAction()))
       );
     }

     @Action(LoadCustomsDepSuccessAction)
     LoadCustomsDepSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadCustomsDepSuccessAction) {
       ctx.patchState({
         showSpinner: false,
         customsDep: action.payload.customsDep
       });
     }

     @Action(LoadCustomsDepFailAction)
     LoadCustomsDepFailAction(ctx: StateContext<LookupStateModel>, action: LoadCustomsDepFailAction) {
       ctx.patchState({
         showSpinner: false,
         customsDep: undefined
       });
     }

     //-----------------------------------------------------

     @Action(LoadDeclarationTypesAction)
     LoadDeclarationTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>, action: LoadDeclarationTypesAction) {
       patchState({ showSpinner: true });

       return this.lookupsClient.getDeclarationTypes().pipe(
         tap((declarationTypes) => dispatch(new LoadDeclarationTypesSuccessAction({ declarationTypes }))),
         catchError((err) => dispatch(new LoadDeclarationTypesFailAction()))
       );
     }

     @Action(LoadDeclarationTypesSuccessAction)
     LoadDeclarationTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadDeclarationTypesSuccessAction) {
       ctx.patchState({
         showSpinner: false,
         declarationTypes: action.payload.declarationTypes
       });
     }

     @Action(LoadDeclarationTypesFailAction)
     LoadDeclarationTypesFailAction(ctx: StateContext<LookupStateModel>, action: LoadDeclarationTypesFailAction) {
       ctx.patchState({
         showSpinner: false,
         declarationTypes: undefined
       });
     }

     @Action(LoadAllTypesAction)
     loadAllTypesAction({ dispatch, patchState }: StateContext<LookupStateModel>) {
         patchState({ showSpinner: true });

         return this.lookupsClient.getAllTypes().pipe(
             tap((types) => dispatch(new LoadAllTypesSuccessAction({ types }))),
             catchError((err) => dispatch(new LoadAllTypesFailAction()))
         );
     }

     @Action(LoadAllTypesSuccessAction)
     loadAllTypesSuccessAction(ctx: StateContext<LookupStateModel>, action: LoadAllTypesSuccessAction) {
         ctx.patchState({
             showSpinner: false,
             allTypes: action.payload.types
         });
     }

     @Action(LoadAllTypesFailAction)
     loadAllTypesFailAction(ctx: StateContext<LookupStateModel>) {
         ctx.patchState({
             showSpinner: false,
             allTypes: undefined
         });
     }
}
